import { Outlet, useMatches } from "react-router-dom";
import Sidebar from "./widgets/Sidebar";
import DashboardHeader from "./widgets/Header";
import { SidebarProvider, useSidebar } from "./context/SidebarContext";

const AdminDashboardLayout = () => {
    return (
        <SidebarProvider>
            <AdminDashboardLayoutContent />
        </SidebarProvider>
    );
};

const AdminDashboardLayoutContent = () => {
    const { isCollapsed } = useSidebar();
    const matches = useMatches();
    const pageTitle = matches.filter((match) => Boolean(match.handle?.title)).at(-1)?.handle?.title || "Dashboard Overview";
    return (
        <div className="flex min-h-screen">
            <Sidebar />
            <DashboardHeader
                className={`fixed top-0 z-30 bg-gray-700 text-white p-4 flex items-center justify-between shadow-md h-16 transition-all duration-300 ease-in-out
                    ${isCollapsed ? "left-20" : "left-64"} right-0`}
                pageTitle={pageTitle}
            />
            <div className={`flex-1 py-2 sm:px-4 pt-24 transition-all duration-300 ease-in-out ${isCollapsed ? "ml-20" : "ml-64"} overflow-x-auto`}>
                <Outlet />
            </div>
        </div>
    );
};

export default AdminDashboardLayout;
